import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import { actionCalendarNavCalendarView, actionCalendarNavListView } from 'actions';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // border: "solid 1px",
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));



const handleCalendarViewChange = (viewType, dispatch) => {

  if (viewType === "CalendarView") {
    actionCalendarNavCalendarView(dispatch);
  }
  else {
    actionCalendarNavListView(dispatch);
  }

}

const CalendarNavBar = props => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const bookingType = useSelector(state => state.reducerBookingTypes.bookingType);
  const displayAreasState = useSelector(state => state.reducerDisplayAreas);
  const [disableCalendarLink, setdisableCalendarLink] = React.useState(false);

  useEffect(() => {

    if (props.Path == "/calendar/:id") {

      if (props.bookingType != undefined) {
        if (props.bookingType && props.bookingType.ForceListView) {
          setdisableCalendarLink(true);
        }
        else {
          setdisableCalendarLink(false);
        }
      }
    }
    else {
      if (displayAreasState.displayAreas !== undefined && displayAreasState.displayAreas.length > 0) {
        let newDisplayAreas = JSON.parse(JSON.stringify(displayAreasState.displayAreas));
        let newObj = { ...newDisplayAreas.filter(x => x.DisplayAreaNo == props.urlID)[0] };

        if (newObj && newObj.ForceListView) {
          setdisableCalendarLink(true);
        }
        else {
          setdisableCalendarLink(false);
        }
      }
    }

  }, [bookingType, displayAreasState]);


  return (
    <div className={classes.root}>
      <ButtonGroup variant="text" color="primary" aria-label="text primary button group">
        <Button onClick={() => handleCalendarViewChange("CalendarView", dispatch)} disabled={disableCalendarLink}>Calendar View</Button>
        <Button onClick={() => handleCalendarViewChange("ListView", dispatch)}>List View</Button>
      </ButtonGroup>
    </div>
  );
}

export default CalendarNavBar;
